import type { Reducer } from '../types/state';

const exporter =
  <S>(initialState: S, handlers: Record<string, Reducer<S>>) =>
  (state = initialState, action: any) =>
    action && handlers[action.type] ? handlers[action.type](state, action) : state;

export default exporter;
